import axios from "axios"
import { AllblogLoading, AllblogSuccess, Allblogfail, GetSingleblogLoading, GetSingleblogSuccess, GetSingleblogfail, UpdateblogCreateLoading, UpdateblogCreateSuccess, blogCreateLoading, blogCreateSuccess, blogCreatefail, DeleteBlogLoading, DeleteBlogSuccess, DeleteBlogFail } from "../slices/blogSlices"
import { toast } from "react-toastify"
import { mainurl } from "./mainurl"

const baseurl = mainurl


export const CreateNewBlogs = (blogdata) => async (dispatch) => {

    try {
        dispatch(blogCreateLoading())
        const { data } = await axios.post(`${baseurl}/blog/newblog`, blogdata, { withCredentials: true })
        dispatch(blogCreateSuccess(data))
        toast.success("blog created successfully")
    } catch (error) {
        dispatch(blogCreatefail(error.response.data.message))
        toast.error(error.response.data.message)
    }
}

export const Allblogs = async (dispatch) => {
    try {
        dispatch(AllblogLoading())
        const { data } = await axios.get(`${baseurl}/blog/allblog`)
        console.log();
        dispatch(AllblogSuccess(data))
    } catch (error) {
        dispatch(Allblogfail(error.response.data.message))
    }
}

export const GetsingleBlog = (blog) => async (dispatch) => {
    try {
        dispatch(GetSingleblogLoading())
        const { data } = await axios.get(`${baseurl}/blog/single-blog/${blog}`)
        dispatch(GetSingleblogSuccess(data))
    } catch (error) {
        dispatch(GetSingleblogfail(error.response.data.message))
        toast.error(error.response.data.message)
    }
}

export const UpdateBlogs = (id, blogdata) => async (dispatch) => {

    try {
        dispatch(UpdateblogCreateLoading())
        const { data } = await axios.put(`${baseurl}/blog/single-blog/${id}`, blogdata, { withCredentials: true })
        dispatch(UpdateblogCreateSuccess(data))
        toast.success("blog updated")
    } catch (error) {
        dispatch(blogCreatefail(error.response.data.message))
        toast.error(error.response.data.message,)
    }
}

export const DeleteSingleBlog = (id) => async (dispatch) => {

    try {
        dispatch(DeleteBlogLoading())
        const { data } = await axios.delete(`${baseurl}/blog/single-blog/${id}`, { withCredentials: true })
        dispatch(DeleteBlogSuccess(data))
        toast.success("Deleted")
    } catch (error) {
        dispatch(DeleteBlogFail(error.response.data.message))
        toast.error(error.response.data.message)
    }
}

// export const allCategory = async (req, res) => {

//     const data = await categorys.find({})

//     const value = data.filter(item => item.categories).map(item => item.categories);
//     res.status(200).json({
//         success: true,
//         value
//     })

// }


// export const createCategory = async (req, res) => {

//     const { category } = req.body

//     const categorydata = await categorys.findOne({ categories: category })

//     if (!categorydata) {

//         const data = await categorys.create({ categories: category })
//         res.status(200).json({ message: "Category created successfully" })
//     } else {
//         res.status(200).json({ message: "Already Category created" })
//     }

// }


// export const updateCategory = async (req, res) => {
//     const { id } = req.params;
//     const { category } = req.body;

//     try {
//         const updatedCategory = await categorys.findByIdAndUpdate(
//             id,
//             { categories: category },);

//         if (updatedCategory) {
//             res.status(200).json({ message: "Category updated successfully" });
//         } else {
//             res.status(404).json({ message: "Category not found" });
//         }
//     } catch (error) {
//         console.log(error);
//     }
// }